import React from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const WhetherSufficientDialog = ({
  open,
  onClose,
  onConfirm
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    maxWidth="md"
    fullWidth
  >
    <DialogTitle
      className="dialog-title"
      sx={{ fontSize: "1.5rem", fontWeight: "700", position: "relative" }}
      id="alert-dialog-title"
    >
      Alert
      <IconButton
        aria-label="close"
        onClick={onClose}
        className="close-icon"
        sx={{ position: "absolute", right: 18, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers className="dialog-content">
      <Typography variant="body2" className="dialog-description">
        In case of restricted ROW, the utility services can be allowed beneath the carriageway of the service road, subject to the condition that the utility services are laid in concrete ducts designed to carry traffic on top. The width of the ducts shall not be less than one lane. Maintenance must not interfere with safe and smooth traffic flow. The cost of operation and maintenance will be borne by the licensee as per the agreement.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ py: 1, px: 2 }}>
      <Button
        variant="contained"
        className="stepper-next-btn"
        sx={{ width: "auto" }}
        onClick={() => {
          onConfirm();
        }}
      >
        I Agree
      </Button>
    </DialogActions>
  </Dialog>
); 